import React from 'react';
import { Phone, CalendarCheck, Shield } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function ResultsSection() {
  const outcomes = [{
    icon: <Phone className="w-8 h-8 text-[#c9a84c]" data-id="element-563" />,
    title: 'More Calls',
    desc: 'A website that makes your phone ring'
  }, {
    icon: <CalendarCheck className="w-8 h-8 text-[#c9a84c]" data-id="element-564" />,
    title: 'More Bookings',
    desc: 'Turn visitors into paying customers'
  }, {
    icon: <Shield className="w-8 h-8 text-[#c9a84c]" data-id="element-565" />,
    title: 'More Trust',
    desc: 'Look established and professional online'
  }];
  return <section id="results" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-566">
      <div className="max-w-6xl mx-auto" data-id="element-567">
        <div className="text-center mb-16 reveal" data-id="element-568">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-569">
            Website Design That Converts Visitors Into{' '}
            <span className="gold-gradient-text" data-id="element-570">Customers</span>
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto" data-id="element-571">
            Built for Dublin businesses to turn visitors into messages and
            calls.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-572">
          {outcomes.map((item, idx) => <div key={idx} className="premium-card p-8 rounded-xl text-center space-y-4 reveal" style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-573">
              <div className="bg-[#c9a84c]/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-574">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-575">{item.title}</h3>
              <p className="text-white/70" data-id="element-576">{item.desc}</p>
            </div>)}
        </div>
      </div>
      <SectionDivider data-id="element-577" />
    </section>;
}